import { SearchParamNames } from '../../../models/enums';
import { CheckboxAction } from './SearchActions';
import { SearchState } from './searchReducer';

const checkboxReducer = (state: SearchState, action: CheckboxAction): SearchState => {
    const { checked, value } = action.payload;

    switch (action.type) {
        case SearchParamNames.CourseTypes: {
            const courseTypes = new Set(state.courseTypes);
            const courseType = value;

            if (checked) {
                courseTypes.add(courseType);
            } else {
                courseTypes.delete(courseType);
            }

            return { ...state, courseTypes };
        }
        case SearchParamNames.Topics: {
            const topics = new Set(state.topics);
            const topicName = value;
            const subTopics = new Set(state.subTopics);
            const relatedSubTopics = state.topicMap[topicName].subTopics;

            if (checked) {
                topics.add(topicName);
                relatedSubTopics.forEach((topicSubTopic) => subTopics.add(topicSubTopic));
            } else {
                topics.delete(topicName);
                relatedSubTopics.forEach((topicSubTopic) => subTopics.delete(topicSubTopic));
            }

            return { ...state, subTopics, topics };
        }
        case SearchParamNames.SubTopics: {
            const topics = new Set(state.topics);
            const subTopics = new Set(state.subTopics);
            const subTopic = value;
            const topic = state.subTopicMap[subTopic].topic;

            if (checked) {
                subTopics.add(subTopic);
                topics.add(topic);
            } else {
                subTopics.delete(subTopic);

                const relatedSubTopics = state.topicMap[topic].subTopics;
                if (!relatedSubTopics.some((relatedSubTopic) => subTopics.has(relatedSubTopic))) {
                    topics.delete(topic);
                }
            }

            return { ...state, subTopics, topics };
        }
        /* istanbul ignore next */
        default: {
            console.error(new Error(`Unrecognized action: ${JSON.stringify(action, null, 2)}`));

            return state;
        }
    }
};

export { checkboxReducer };
